
import { env } from './env';
import axios from 'axios';

const http = axios.create({
   baseURL: env.REACT_APP_API_URL,
   headers: {
      'Content-type': 'application/json',
      'X-Requested-With': 'application/json',
      //"Access-Control-Allow-Headers": "Authorization",
      //"Access-Control-Allow-Origin": "*",
   },
});

export default http;

http.interceptors.request.use(
   (config) => {
      const token = localStorage.getItem('accessToken');

      // @ts-ignore
      config.headers.common['Authorization'] = token ? `Bearer ${token}` : '';

      return config;
   },
   (error) => Promise.reject(error)
);
